/* istanbul ignore file: we do not need to care about the entry point file as errors are detected through E2E */

/**
 * The entrypoint for the knowledgebase search shortcode.
 */
import "@devowl-wp/utils/lib/antd.scss";
import { render } from "react-dom";
import { KnowledgeBaseSearch } from "./shortcode/knowledgeBaseSearch";
import $ from "jquery";
import { Provider } from "./components";
import { ready } from "@devowl-wp/react-utils";
ready().then(() => {
  // Query DOM for all widget wrapper divs
  const elements = document.querySelectorAll("div.devowl-knowledge-base-search");

  // Iterate over the DOM nodes and render a React component into each node
  elements.forEach(item => render( /*#__PURE__*/React.createElement(Provider, null, /*#__PURE__*/React.createElement(KnowledgeBaseSearch, $(item).data())), item));
});